document.addEventListener('DOMContentLoaded', function() {
    // Initially, show all FAQ tabs
    document.querySelectorAll('.faq-tab-pane').forEach(function(pane) {
        pane.classList.add('active');
    });

    // Add click event for each tab
    document.querySelectorAll('.faq-tab-title').forEach(function(tab) {
        tab.addEventListener('click', function() {
            var targetTab = this.getAttribute('data-tab');

            // Remove 'active' class from all tabs
            document.querySelectorAll('.faq-tab-title').forEach(function(item) {
                item.classList.remove('active');
            });

            // Add 'active' class to clicked tab
            this.classList.add('active');

            // Hide all the FAQ tab panes
            document.querySelectorAll('.faq-tab-pane').forEach(function(pane) {
                pane.classList.remove('active');
            });

            // Show the selected tab's FAQ content
            document.querySelectorAll('.' + targetTab).forEach(function(pane) {
                pane.classList.add('active');
            });
        });
    });

    // FAQ toggle (expand and collapse)
    document.querySelectorAll('.faq-question').forEach(function(question) {
        question.addEventListener('click', function() {
            var answer = this.nextElementSibling; // The next div is the answer
            var toggleIcon = this.querySelector('.faq-toggle-icon');

            // Toggle the answer visibility
            answer.classList.toggle('active');
            // Toggle the icon between "+" and "-"
            toggleIcon.textContent = answer.classList.contains('active') ? '-' : '+';
        });
    });
});
